<template>
    <b-card no-body >
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info">
                <b-icon icon="search" aria-hidden="true"></b-icon>
                Filtro de busqueda
            </b-button>
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
                <b-card-text>
                    <b-row>
                        <b-col cols="12" md="4">
                            <label for="cliente">Cliente</label>
                            <b-form-input id="cliente" v-model="filter.cliente" @keydown.enter.prevent="$emit('get-clientes')" placeholder="Cliente"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="documento">Nit Cliente</label>
                            <b-form-input id="documento" v-model="filter.documento" @keydown.enter.prevent="$emit('get-clientes')" placeholder="Nit Cliente"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="tipoDocumento">Tipo Documento</label>
                            <b-form-select
                                v-model="filter.tipoDocumento"
                                :options="tipoDocumento"
                                id="tipoDocumento"
                                class="mb-3"
                                value-field="tipo"
                                text-field="label"
                                >
                                <template #first>
                                    <b-form-select-option value="">SELECCIONE</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" md="12">
                            <div >
                                <b-button variant="info" @click.prevent="$emit('get-clientes')" class="mx-1">
                                    <b-icon icon="search" aria-hidden="true"></b-icon>
                                    Buscar
                                </b-button>
                                <b-button variant="warning" @click.prevent="$emit('clear-filter-form')" class="mx-1 text-white">
                                    <b-icon icon="backspace" aria-hidden="true"></b-icon>
                                    Limpiar
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-text>
            </b-card-body>
        </b-collapse>
    </b-card>
    
</template>

<script>
export default {
    name: "FilterForm",
    props: {
        filter: {
            type: Object
        },
        tipoDocumento: {}
    }
};

</script>
<style scoped>

</style>